export default {
    cptDataForm:{dataText:'{"value":"275.39","unit":"Kb/s"}',dataSource: 1, pollTime: 0,apiUrl:'/text'},
    attribute:{
        title:'当月公网流出总流量',numColor:'#32B0FF',numSize:20,numHeight:30,labelColor:'#ddd',labelSize:13,fontFamily:'CAI978',
        alarmConfig:{
            operator:'>',
            threshold:'',
            color:'#f00'
        },
        cptTableData:[{"name":"指标","value":"","namekey":"value"},{"name":"单位","value":"","namekey":"unit"}]
    },
}